























import Vue from 'vue';
import Component from 'vue-class-component';
import DRadio from '../../index';

Vue.use(DRadio);
@Component({
  name: 'Demo1'
})
export default class Demo1 extends Vue {
  public options = [{
    value: 1, label: '选项1'
  }, {
    value: 2, label: '选项2'
  }];
  public value = 2;
  public value2 = 1;
  public value3 = 1;

  public valueChanged() {
  }
}
